import { Action } from "..";

import { MaterialUpdate } from "../../types/materialUpdate";
import { LAST_MATERIAL_UPDATED_CHANGE } from "../actions/lastMaterialUpdated";

export interface MaterialState {
  material: MaterialUpdate | null;
}

const initialState: MaterialState = {
  material: null,
};

const lastMaterialUpdatedReducer = (
  state: MaterialState = initialState,
  action: Action
): MaterialState => {
  switch (action.type) {
    case LAST_MATERIAL_UPDATED_CHANGE:
      return { ...state, material: action.payload };
    default:
      return state;
  }
};

export default lastMaterialUpdatedReducer;
